import React, { Component } from 'react';
import Transition from 'react-transition-group/Transition';


import WorkComponent from './WorkComponent.js';
import navigation from '../navigation';



class Overlay extends Component {
	constructor(props) {
		super(props)

		this.state = {
			in: true
		}
	}
	

	render(){
		const defaultStyle = {
		  transition: `all 1000ms cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
		  opacity: this.props.overlayOpacity,
		  display: "block"
		}

		return(
			<Transition
			in={this.state.in}
			timeout={5000}
			mountOnEnter={true}>
				{
					(state) =>{

						return(
							<div className="Overlay" style={{
								...defaultStyle
							}}>
								<div className="PageTitle">
									<h1>Bradley McGovern</h1>
									<h2>Front-end Developer</h2>
									<p>Loading...</p>
								</div>
								
							</div>
						)
					}		
				}
			</Transition>	
			)
		}

}

export default Overlay;


// WEBPACK FOOTER //
// ./src/components/Overlay.js